import "../../css/pages/SpanishPage.scss";
import BasePage from "../modules/basePage";

class SpanishPage extends BasePage {
    constructor(...opts) {
        super(...opts);
    }

    init() {
        super.init();
    }

    onReady() {
        super.onReady();
    }
}

new SpanishPage();
